<template>
	<component :is="currentStatistikView" ref="childComponent" />
</template>

<script>
import { computed, defineComponent } from 'vue';
import { useStore } from '../store';
import Statistik from '@/views/Statistik.vue';
import StatistikPublic from '@/views/StatistikPublic.vue';

export default defineComponent({
	name: 'StatistikWrapper',
	components: {},
	setup() {
		const store = useStore();
		const user = computed(() => store.state.user);
		const loggedin = computed(() => store.state.loggedin);
		const isLoggedIn = loggedin.value && user.value;

		const currentStatistikView = computed(() => {
			if (!isLoggedIn) {
				return StatistikPublic;
			}

			return Statistik;
		});

		return {
			currentStatistikView,
		};
	},
});
</script>
